import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SiteUserView } from "./SiteUserView";
import { UserViewStore } from "../../store/UserViewStore";
import { useStore } from "../../../../hooks";
import { siteUserService } from "../../services/siteUserService";

export const SiteUserViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/site-user/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new UserViewStore(rootStore);
      // Proyección: cargar por el documento de la proyección (solo sus campos)
      // en vez del de la entidad — que puede pedir refs que este rol no puede
      // leer (p.ej. CreditPurchase.tenant para un SiteAdmin). Solo se overridea
      // getOne: es lo único que usa el view y sus tipos coinciden.
      s.service = { ...s.service, getOne: siteUserService.getOne };
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            { id: "main", label: rootStore.langStore.groupSiteUserMainLabel },
            {
              id: "details",
              label: rootStore.langStore.groupSiteUserDetailsLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SiteUserView userViewStore={store} />
      </PageLayout>
    </div>
  );
});
